import React, { useState } from "react";
import { Separator } from "../ui/separator";
import gameAssets from "@themed-assets";
import { TOURNEY_STATUS_LIVE, TOURNEY_TYPES } from "@/Poker/data/Constants";
import {
  checkToDisplayValueInK,
  checkToDisplayValueInCr,
  checkToDisplayValueInL,
  parseDecimalValuesOfNumber,
} from "@/Common/utils/GameUtils";
import { formatDistance } from "date-fns";
import CountdownTimer, {
  CountdownTimerUsingSeconds,
} from "../Common/CountdownTimer";
import { getOrdinalSuffix } from "@/src/hooks/utils/useOrdinalUtils";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  PopoverAnchor,
} from "../ui/popover";

function TourneyDetailsOverviewDetailCard({
  isSummary,
  selectedTourneyDetails,
}) {
  const [toggleCard, setToggleCard] = useState(false);

  const {
    tourneyStatus,
    currentLevel,
    currentLevelNumber,
    nextLevelNumber,
    nextLevel,
    maxLevelNumber,
    nextBreak,
    nextBreakStartTimeInEpochSeconds,
    startingStack,
    lateRegEndTime,
    lateRegistrationAllowed,
    reEntry,
    rebuyLevel,
    rebuyFee,
    addOnAmount,
    playersPerTable,
    minPlayers,
    averageChips,
    registeredPlayerCount,
    totalRebuyCount,
    totalAddOnCount,
    minStack,
    maxStack,
    totalReEntryCount,
    tourneyStartTime,
    maxRebuyCount,
    bountyTourneyType,
    bountyBuyIn,
    tourneyFeatures,
    totalAddOns,
    activeTables,
    tourneyIdentifier,
    lowestStack,
    highestStack,
    blindStructure,
    nextBlindLevelStartTimeInSeconds,
    nextBlindLevelEndTimeInEpochSeconds,
    rebuyEndTime,
    tourneyGameConfig = {},
    noOfRebuys,
    reEntryType,
    tournamentType,
  } = selectedTourneyDetails;

  const getCurrentLevelBlind = (type) => {
    if (blindStructure?.length > 0) {
      const filteredLevel = blindStructure.filter(
        (o) => o.level == currentLevelNumber
      )[0];
      if (type == "blind" && filteredLevel) {
        const str = `${parseDecimalValuesOfNumber(
          filteredLevel.sb,
          2,
          checkToDisplayValueInK(filteredLevel.sb),
          checkToDisplayValueInL(filteredLevel.sb),
          checkToDisplayValueInCr(filteredLevel.sb)
        )}/${parseDecimalValuesOfNumber(
          filteredLevel.bb,
          2,
          checkToDisplayValueInK(filteredLevel.bb),
          checkToDisplayValueInL(filteredLevel.bb),
          checkToDisplayValueInCr(filteredLevel.bb)
        )}(${
          parseDecimalValuesOfNumber(
            filteredLevel.ante,
            2,
            checkToDisplayValueInK(filteredLevel.ante),
            checkToDisplayValueInL(filteredLevel.ante),
            checkToDisplayValueInCr(filteredLevel.ante)
          ) || 0
        })`;
        return str;
      }
      if (type == "level") {
        return filteredLevel?.level || 0;
      }
      return "";
    }
  };

  const getNextLevelBlind = () => {
    if (blindStructure?.length > 0) {
      const filteredLevel = blindStructure.filter(
        (o) => o.level == nextLevelNumber
      )[0];
      if (filteredLevel) {
        const str = `${parseDecimalValuesOfNumber(
          filteredLevel.sb,
          2,
          checkToDisplayValueInK(filteredLevel.sb),
          checkToDisplayValueInL(filteredLevel.sb),
          checkToDisplayValueInCr(filteredLevel.sb)
        )}/${parseDecimalValuesOfNumber(
          filteredLevel.bb,
          2,
          checkToDisplayValueInK(filteredLevel.bb),
          checkToDisplayValueInL(filteredLevel.bb),
          checkToDisplayValueInCr(filteredLevel.bb)
        )} Ante - (${
          parseDecimalValuesOfNumber(
            filteredLevel.ante,
            2,
            checkToDisplayValueInK(filteredLevel.ante),
            checkToDisplayValueInL(filteredLevel.ante),
            checkToDisplayValueInCr(filteredLevel.ante)
          ) || 0
        })`;
        return str;
      }
      return "";
    }
  };

  const DataCard = ({
    title,
    value,
    valueSecondary,
    isInfo,
    isEntries,
    infoContent = "",
    className = "",
  }) => {
    return (
      <div className={"flex flex-col gap-1 text-secondary"}>
        <div className={`flex items-center`}>
          <span className={"text-2xs text-secondary uppercase mr-1"}>
            {title}
          </span>
          {isInfo && (
            <div>
              <Popover>
                <PopoverTrigger asChild>
                  <img src={gameAssets.InfoIcon} />
                </PopoverTrigger>
                <PopoverContent
                  className={
                    "bg-foreground border-surface border w-fit max-w-40 p-2"
                  }
                >
                  <div className="text-2xs font-medium">{infoContent}</div>
                </PopoverContent>
              </Popover>
            </div>
          )}
        </div>
        {isEntries ? (
          <div>
            <div
              className={
                "whitespace-pre-line flex items-center text-primary text-sm font-bold"
              }
            >
              {value}
              <span className="font-normal text-2xs text-secondary ml-1">
                (Registered)
              </span>
            </div>
            {valueSecondary && (
              <div
                className={
                  "whitespace-pre-line flex items-center text-primary text-sm font-bold mt-0.5"
                }
              >
                {/* {valueSecondary} */}
                {totalReEntryCount}
                <span className="font-normal text-2xs text-secondary ml-1">
                  (Re-entries)
                </span>
              </div>
            )}
          </div>
        ) : (
          <div>
            <div
              className={
                className ||
                "whitespace-pre-line text-sm font-bold text-primary"
              }
            >
              {value}
            </div>
            {valueSecondary && (
              <div
                className={
                  "text-2xs font-bold whitespace-pre-line text-secondary mt-0.5"
                }
              >
                {valueSecondary}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      {isSummary ? (
        <div className={`bg-foreground px-4 pt-4 rounded-300 mt-3 font-title`}>
          <div className="flex items-center mb-3">
            <div className="w-1 h-1 bg-success rounded-full" />
            <div className="text-xs text-secondary font-bold ml-1">Summary</div>
          </div>

          <div className="flex items-start justify-between pb-3">
            {/* 1 */}
            <div
              style={{}}
              className={`flex items-center justify-center w-1/3`}
            >
              <div className={"flex flex-col gap-1 items-center"}>
                <span className={`text-2xs text-secondary uppercase`}>
                  CURRENT BLIND
                </span>
                <span
                  className={
                    "text-sm whitespace-pre-line font-bold text-primary"
                  }
                >
                  {/* 100/200 (10) */}
                  {getCurrentLevelBlind("blind")}
                </span>
                <span className={"text-2xs text-secondary"}>
                  Level - {getCurrentLevelBlind("level")}
                </span>
              </div>
            </div>
            {/* 2 */}
            <div
              style={{}}
              className={`flex items-center justify-center w-1/3`}
            >
              <div className={"flex flex-col gap-1 items-center"}>
                <span className={`text-2xs text-secondary uppercase`}>
                  NEXT BLIND LEVEL IN
                </span>
                <span
                  className={
                    "text-sm whitespace-pre-line font-bold text-primary"
                  }
                >
                  <CountdownTimer
                    // startTime={1754563298765}
                    // startTime={nextBlindLevelStartTimeInSeconds || 0}
                    startTime={nextBlindLevelEndTimeInEpochSeconds * 1000 || 0}
                    isMinutes
                    isSeconds
                  />
                </span>
              </div>
            </div>
            {/* 3 */}
            <div
              style={{}}
              className={`flex items-center justify-center w-1/3`}
            >
              <div className={"flex flex-col gap-1 items-center"}>
                <span className={`text-2xs text-secondary uppercase`}>
                  AVG CHIPS
                </span>
                <span
                  className={
                    "text-sm whitespace-pre-line font-bold text-primary"
                  }
                >
                  {averageChips}
                </span>
              </div>
            </div>
          </div>
          <Separator className={"border-foreground border border-solid"} />
          <Separator className={"border-surface/40 border border-solid"} />
          {!toggleCard && (
            <div className={"grid grid-cols-2 gap-6 py-3"}>
              <DataCard
                title={"Next Blind Level"}
                value={nextLevelNumber || 0}
                valueSecondary={getNextLevelBlind()}
              />
              <DataCard
                title={"Entries"}
                value={`${registeredPlayerCount}`}
                valueSecondary={`${totalReEntryCount || 0}`}
                isEntries
              />
              {(selectedTourneyDetails?.rebuyWithAddon ||
                selectedTourneyDetails?.rebuyWithOutAddon) && (
                // <DataCard title={"RE-BUY COUNT"} value={totalRebuyCount} />
                <DataCard
                  title={"RE-BUY COUNT"}
                  value={
                    selectedTourneyDetails?.[
                      reEntryType == "RebuyWithAddOn"
                        ? "rebuyWithAddon"
                        : "rebuyWithOutAddon"
                    ]?.rebuySettings?.noOfRebuys
                  }
                />
              )}
              {(selectedTourneyDetails?.rebuyWithAddon ||
                selectedTourneyDetails?.rebuyWithOutAddon) && (
                <DataCard
                  title={"RE-BUY ENDS IN"}
                  value={
                    // <CountdownTimer
                    //   startTime={1754563298765}
                    //   // startTime={rebuyEndTime || 0}
                    //   isMinutes
                    //   isSeconds
                    // />
                    <CountdownTimerUsingSeconds
                      endTimeseconds={rebuyEndTime || 0}
                      // endTimeseconds={537025 || 0}
                    />
                  }
                />
              )}
              {/* {totalAddOns > 0 && ( */}
              <DataCard title={"ADD-ON COUNT"} value={totalAddOnCount || 0} />
              {/* )} */}

              <DataCard title={"TABLE RUNNING"} value={activeTables || 0} />
              <DataCard
                title={"NEXT BREAK IN"}
                // value={nextBreak ?? nextBreak}
                className="text-h-alt font-bold text-sm"
                value={
                  <CountdownTimer
                    // startTime={1754563298765000}
                    startTime={nextBreakStartTimeInEpochSeconds * 1000 || 0}
                    isMinutes
                    isSeconds
                  />
                }
              />
              {lowestStack > 0 && tourneyIdentifier !== "completedTourneys" && (
                <DataCard
                  title={"Min / Max Stack"}
                  value={`${
                    parseDecimalValuesOfNumber(
                      lowestStack,
                      2,
                      checkToDisplayValueInK(lowestStack),
                      checkToDisplayValueInL(lowestStack),
                      checkToDisplayValueInCr(lowestStack)
                    ) || 0
                  }/${
                    parseDecimalValuesOfNumber(
                      highestStack,
                      2,
                      checkToDisplayValueInK(highestStack),
                      checkToDisplayValueInL(highestStack),
                      checkToDisplayValueInCr(highestStack)
                    ) || 0
                  }`}
                />
              )}
            </div>
          )}
          <div>
            {!toggleCard && (
              <>
                <Separator
                  className={"border-foreground border border-solid"}
                />
                <Separator
                  className={"border-surface/40 border border-solid"}
                />
              </>
            )}

            <div
              className={`flex items-center pt-3 pb-3 justify-center`}
              onClick={() => {
                setToggleCard(!toggleCard);
              }}
            >
              <div className={`mr-2.5 text-sm font-bold text-ticket`}>
                {toggleCard ? "More" : "Less"}
              </div>
              <img
                width={16}
                height={16}
                className={`animate-bounce ${
                  toggleCard ? "rotate-180 -mt-2" : "-rotate-360 mt-1"
                } delay-400`}
                src={gameAssets.DownArrowCircleIcon}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className={`bg-foreground p-4 rounded-300 mt-3 font-title`}>
          <div className={"grid grid-cols-2 gap-6"}>
            <DataCard
              title={"STARTING STACK"}
              value={`${
                parseDecimalValuesOfNumber(
                  startingStack,
                  2,
                  checkToDisplayValueInK(startingStack),
                  checkToDisplayValueInL(startingStack),
                  checkToDisplayValueInCr(startingStack)
                ) || "0"
              } chips`}
            />
            {/* {lateRegistrationAllowed && ( */}
            <DataCard
              title={"LATE REGISTRATION"}
              // value={`upto ${formatDistance(
              //   new Date(1753200890934),
              //   new Date(1753200807999)
              // )}`}
              value={
                lateRegistrationAllowed
                  ? `upto ${formatDistance(
                      new Date(tourneyStartTime * 1000),
                      new Date(lateRegEndTime * 1000)
                    )}`
                  : "Not allowed"
              }
              // valueSecondary={"Till 8th level|HC"}
            />
            {/* )} */}
            {/* {reEntry?.reEntrySettings && ( */}
            <DataCard
              title={"RE-ENTRY"}
              value={
                reEntry?.reEntrySettings
                  ? reEntry?.reEntrySettings.noOfReentry
                  : "Not allowed"
              }
              valueSecondary={
                reEntry?.reEntrySettings
                  ? `Till ${getOrdinalSuffix(
                      reEntry?.reEntrySettings.reentryLevel || 0
                    )} Level`
                  : ""
              }
            />
            {/* )} */}

            {/* reEntryType: "RebuyWithoutAddOn" || "RebuyWithAddOn" */}
            {/* {selectedTourneyDetails?.[
                reEntryType == "RebuyWithAddOn"
                  ? "rebuyWithAddon"
                  : "rebuyWithOutAddon"
              ]?.rebuySettings?.noOfRebuys && ( */}
            <DataCard
              title={"RE-BUY"}
              value={
                reEntryType === "RebuyWithoutAddOn" ||
                reEntryType === "RebuyWithAddOn"
                  ? `Upto ${
                      selectedTourneyDetails?.[
                        reEntryType == "RebuyWithAddOn"
                          ? "rebuyWithAddon"
                          : "rebuyWithOutAddon"
                      ]?.rebuySettings?.noOfRebuys
                    } rebuys`
                  : "Not allowed"
              }
              valueSecondary={
                reEntryType === "RebuyWithoutAddOn" ||
                reEntryType === "RebuyWithAddOn"
                  ? `Till ${getOrdinalSuffix(
                      selectedTourneyDetails?.[
                        reEntryType == "RebuyWithAddOn"
                          ? "rebuyWithAddon"
                          : "rebuyWithOutAddon"
                      ]?.rebuySettings?.rebuyLevel || 0
                    )} Level`
                  : ""
              }
            />
            {/* )} */}
            {bountyTourneyType && (
              <DataCard
                title={"BOUNTY TYPE"}
                value={bountyTourneyType || ""}
                valueSecondary={`₹${bountyBuyIn} / Player`}
              />
            )}
            <DataCard
              title={"DEAL MAKING"}
              value={`${
                tourneyFeatures?.dealMaking ? "Allowed" : "Not allowed"
              }`}
              isInfo
              infoContent={
                "Allows final X players to negotiate a deal to chop the prize pool."
              }
            />
            {tourneyGameConfig && (
              <DataCard
                title={"TIME BANK"}
                value={`${tourneyGameConfig?.extraTime || 0} seconds`}
                isInfo
                infoContent={`Extra time for your big decisions. Refreshes every ${
                  tourneyGameConfig?.extraTimeFrequencyBlindLevel ?? 0
                } levels. Max Cap: ${
                  tourneyGameConfig?.extraTimeMaxCap ?? 0
                } secs`}
              />
            )}
            {tourneyGameConfig && (
              <DataCard
                title={"DISCONNECTION TIME"}
                value={`${tourneyGameConfig?.disconnectionTime || 0} seconds`}
                isInfo
                infoContent={` Protection from auto-fold if you disconnect. Refreshes every ${
                  tourneyGameConfig?.disconnectionTimeFrequencyBlindLevel ?? 0
                } levels. Max Cap: ${
                  tourneyGameConfig?.disconnectionTimeMaxCap ?? 0
                } secs.`}
              />
            )}
            {addOnAmount > 0 && <DataCard title={"ADDON"} value={`Allowed`} />}
            <DataCard
              title={"BREAK"}
              value={"Available"}
              valueSecondary={"Every 25th minute, past the hour"}
            />
            <DataCard
              title={"PLAYERS PER TABLE"}
              value={`${playersPerTable || 0}-Max`}
            />
            {tournamentType !== TOURNEY_TYPES.FLIGHT_PARENT && (
              <DataCard
                title={"MINIMUM PLAYERS REQUIRED"}
                value={`${minPlayers || 0}-Players`}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default TourneyDetailsOverviewDetailCard;

const TourneyDetailsOverviewDetailCardData = [
  { title: "STARTING STACK", key: "startingStack" },
  { title: "LATE REGISTRATION", key: "Upto 100 minutes\nTill 8th level" },
  { title: "RE-ENTRY", key: "Unlimited\nTill Xth Level" },
  { title: "RE-BUY", key: "Upto 10 rebuys\nTill Xth Level" },
  { title: "BOUNTY TYPE", key: "Standard\n₹200 / Player" },
  { title: "DEAL MAKING", key: "Allowed" },
  { title: "TIME BANK", key: "XX seconds" },
  { title: "DISCONNECTION TIME", key: "XX seconds" },
  { title: "ADDON", key: "Allowed" },
  { title: "BREAK", key: "Available\nEvery 25th minute, past the hour" },
  { title: "PLAYERS PER TABLE", key: "8-Max" },
];

const mockblindStructure = [
  {
    bb: 20,
    ante: 0,
    level: 1,
    sb: 10,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 40,
    ante: 0,
    level: 2,
    sb: 20,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 60,
    ante: 0,
    level: 3,
    sb: 30,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 80,
    ante: 0,
    level: 4,
    sb: 40,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 100,
    ante: 0,
    level: 5,
    sb: 50,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 120,
    ante: 0,
    level: 6,
    sb: 60,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 150,
    ante: 0,
    level: 7,
    sb: 75,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 200,
    ante: 20,
    level: 8,
    sb: 100,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 250,
    ante: 25,
    level: 9,
    sb: 125,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 300,
    ante: 30,
    level: 10,
    sb: 150,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 400,
    ante: 40,
    level: 11,
    sb: 200,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 500,
    ante: 50,
    level: 12,
    sb: 250,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 600,
    ante: 60,
    level: 13,
    sb: 300,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 800,
    ante: 80,
    level: 14,
    sb: 400,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 1000,
    ante: 100,
    level: 15,
    sb: 500,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 1200,
    ante: 120,
    level: 16,
    sb: 600,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 1400,
    ante: 140,
    level: 17,
    sb: 700,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 1600,
    ante: 160,
    level: 18,
    sb: 800,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 1800,
    ante: 180,
    level: 19,
    sb: 900,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 2000,
    ante: 200,
    level: 20,
    sb: 1000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 2500,
    ante: 250,
    level: 21,
    sb: 1250,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 2800,
    ante: 280,
    level: 22,
    sb: 1400,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 3000,
    ante: 300,
    level: 23,
    sb: 1500,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 3500,
    ante: 350,
    level: 24,
    sb: 1750,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 4000,
    ante: 400,
    level: 25,
    sb: 2000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 5000,
    ante: 500,
    level: 26,
    sb: 2500,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 6000,
    ante: 600,
    level: 27,
    sb: 3000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 7000,
    ante: 700,
    level: 28,
    sb: 3500,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 8000,
    ante: 800,
    level: 29,
    sb: 4000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 9000,
    ante: 900,
    level: 30,
    sb: 4500,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 10000,
    ante: 1000,
    level: 31,
    sb: 5000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 12000,
    ante: 1200,
    level: 32,
    sb: 6000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 14000,
    ante: 1400,
    level: 33,
    sb: 7000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 16000,
    ante: 1600,
    level: 34,
    sb: 8000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 18000,
    ante: 1800,
    level: 35,
    sb: 9000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 20000,
    ante: 2000,
    level: 36,
    sb: 10000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 25000,
    ante: 2500,
    level: 37,
    sb: 12500,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 30000,
    ante: 3000,
    level: 38,
    sb: 15000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 35000,
    ante: 3500,
    level: 39,
    sb: 17500,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 40000,
    ante: 4000,
    level: 40,
    sb: 20000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 50000,
    ante: 5000,
    level: 41,
    sb: 25000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 60000,
    ante: 6000,
    level: 42,
    sb: 30000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 70000,
    ante: 7000,
    level: 43,
    sb: 35000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 80000,
    ante: 8000,
    level: 44,
    sb: 40000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 100000,
    ante: 10000,
    level: 45,
    sb: 50000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 120000,
    ante: 12000,
    level: 46,
    sb: 60000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 150000,
    ante: 15000,
    level: 47,
    sb: 75000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 200000,
    ante: 20000,
    level: 48,
    sb: 100000,
    levelDuration: 0,
    finalLevel: false,
  },
];
